import { ExportToExcel } from '@/services/excel/generator/excelGenerator';
import ExportExcel from '@/services/excel/generator/exportExcel';
import SheetExcel from '@/services/excel/generator/sheetExcel';
import ColumnExcel from '@/services/excel/generator/columnExcel';

export const columns = [
  new ColumnExcel('refExterneTiers', 'refExterneTiers', true),
  new ColumnExcel('Date demande', 'date', true),
  new ColumnExcel('Campagne', 'libelleCampagne', true),
  new ColumnExcel('Code Dispositif', 'codeDispositif', true),
  new ColumnExcel('Image', 'image', false),
];

export function templateConfig(data) {
  return new ExportExcel(
    'TemplateDemandesImpressions.xlsx',
    [
      new SheetExcel(
        'DemandesImpression',
        columns,
        data,
        { skipHeader: false },
      ),
    ],
  );
}

export function generatedTemplateDemandeImpression() {
  const exemple = {
    refExterneTiers: 'S12',
    date: '31/05/2023',
    libelleCampagne: 'Les Mercredeal - JUIN 2023',
    codeDispositif: '5',
    image: 'https://extranet.bachup.fr/img_bache/101315c91fba3.jpg',
  };
  const config = templateConfig([exemple]);
  ExportToExcel(config);
}
